import { motion } from 'framer-motion';

interface Props {
  name: string;
  photoUrl?: string | null;
  cardCount?: number;
  active?: boolean;
  /** 0..1 fraction of turn timer remaining */
  timer?: number;
}

export function PlayerBadge({ name, photoUrl, cardCount, active, timer }: Props) {
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const dash = timer != null ? circumference * timer : 0;
  return (
    <div className="flex items-center gap-2">
      <div className="relative" style={{ width: 64, height: 64 }}>
        {active && (
          <motion.svg
            viewBox="0 0 64 64"
            className="absolute inset-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <circle
              cx="32"
              cy="32"
              r={radius}
              fill="none"
              stroke="color-mix(in oklab, var(--color-gold) 35%, transparent)"
              strokeWidth="3"
            />
            {timer != null && (
              <circle
                cx="32"
                cy="32"
                r={radius}
                fill="none"
                stroke="var(--color-gold)"
                strokeWidth="3"
                strokeLinecap="round"
                strokeDasharray={`${dash} ${circumference}`}
                transform="rotate(-90 32 32)"
              />
            )}
          </motion.svg>
        )}
        <div
          className="m-1 h-[56px] w-[56px] overflow-hidden rounded-full bg-felt-deep"
          style={{ border: '1px solid color-mix(in oklab, var(--color-gold) 60%, transparent)' }}
        >
          {photoUrl ? (
            <img src={photoUrl} alt={name} className="h-full w-full object-cover" />
          ) : (
            <div className="grid h-full w-full place-items-center text-gold" style={{ fontFamily: 'var(--font-display)' }}>
              {name.slice(0, 1).toUpperCase()}
            </div>
          )}
        </div>
        {cardCount !== undefined && (
          <span
            className="absolute -bottom-1 -right-1 grid place-items-center rounded-full"
            style={{
              width: 22,
              height: 22,
              background: 'var(--color-felt-deep)',
              border: '1px solid var(--color-gold)',
              color: 'var(--color-gold)',
              fontFamily: 'var(--font-display)',
              fontSize: 12,
            }}
          >
            {cardCount}
          </span>
        )}
      </div>
    </div>
  );
}
